export default [
    { "vendorId":11374,"vendorName":"Brilliant Orlando FL"},
    { "vendorId":20931,"vendorName":"Diamond group"},
    { "vendorId":18020,"vendorName":"E - POLL"},
    { "vendorId":17688,"vendorName":"MRC"},
    { "vendorId":19062,"vendorName":"Q-Score"},
    { "vendorId":20934,"vendorName":"NRG"}

]